import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { MyContextProvider } from "./context/credentialContext";
import { Toaster } from "react-hot-toast";

import Home from "./pages/Home";
import Supporters from "./pages/Supporters";
import Patron from "./pages/Patron";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";

function App() {
  return (
    <MyContextProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/patrons" element={<Patron />} />
          <Route path="/supporters" element={<Supporters />} />

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<Terms />} />
        </Routes>
      </Router>
      <Toaster />
    </MyContextProvider>
  );
}

export default App;
